import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Status, PutUserInfo, PostUserInfo } from '../../services/apiTypes';
import {
  getUser as getUserAPI,
  updateUser as updateUserAPI,
  createUser as createUserAPI,
  deleteUser as deleteUserAPI,
  UserSearchParam,
} from './api';

interface UserListState {
  status: Status;
}

const initialState: UserListState = {
  status: 'idle',
};

export const getUser = createAsyncThunk(
  'user/getUser',
  async (params: UserSearchParam, { rejectWithValue }) => {
    try {
      return await getUserAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createUser = createAsyncThunk(
  'userList/createUser',
  async (targetUser: PostUserInfo, { rejectWithValue }) => {
    try {
      return await createUserAPI(targetUser);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateUser = createAsyncThunk(
  'userList/updateUser',
  async (targetUser: PutUserInfo, { rejectWithValue }) => {
    try {
      return await updateUserAPI(targetUser);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteUser = createAsyncThunk(
  'userList/deleteUser',
  async (userId: string, { rejectWithValue }) => {
    try {
      return await deleteUserAPI(userId);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const userListSlice = createSlice({
  name: 'userList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getUser.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(getUser.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(createUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createUser.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(createUser.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updateUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateUser.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(deleteUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteUser.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default userListSlice.reducer;
